export const teacherColor = {
    bg: '#F3C520',
    text: '#1C1C1C',
}

export const studentColors = [
    {
        bg: '#A8D067',
        text: '#1C1C1C',
    },
    {
        bg: '#8045AE',
        text: '#FFFFFF',
    },
    {
        bg: '#FF9393',
        text: '#FFFFFF',
    },
    {
        bg: '#58B7E6',
        text: '#FFFFFF',
    },
    {
        bg: '#FFEEB1',
        text: '#1C1C1C',
    },
    {
        bg: '#92D0B9',
        text: '#1C1C1C',
    },
    {
        bg: '#C3ACF3',
        text: '#1C1C1C',
    },
    {
        bg: '#FDD4C9',
        text: '#FFFFFF',
    },
    {
        bg: '#418DCA',
        text: '#FFFFFF',
    },
    {
        bg: '#FF6523',
        text: '#FFFFFF',
    },
    {
        bg: '#4FA858',
        text: '#1C1C1C',
    },
    {
        bg: '#EEC0E3',
        text: '#1C1C1C',
    },
    {
        bg: '#BBE7FF',
        text: '#1C1C1C',
    },
    {
        bg: '#EE4089',
        text: '#FFFFFF',
    },
]

export const allColors = [teacherColor, ...studentColors]

export const getProgressColor = (percentage = 0) => {
    let color = '#222222' // default black

    if (percentage > 0 && percentage <= 16) {
        color = '#D2222D' // red
    } else if (percentage >= 17 && percentage <= 50) {
        color = '#FFBF00' // yellow
    } else if (percentage > 50) {
        color = '#238823' // green
    }

    return color
}
